import i18n from '@/i18n'
import store from '@/store'

export default {
  handleError(error, messageValues = []) {
    if (error?.response?.status) {
      const status = typeof error === 'object' ? error.response.status : error
      if (status === 0) {
        store.dispatch('Global/showMessage', 'noInternetConnection')
        return
      }

      if (status === 401) {
        store.dispatch('Auth/signout')
        return
      }

      if (status === 503 || status === 429) {
        store.dispatch('Global/showMessage', 'unkownErrorHasOccured')
        return
      }

      store.dispatch('Global/showMessage', (this.getErrorMessage(error.response.data, status, messageValues)))
    }
  },
  getErrorMessage(response, status, messageValues) {
    const errorKey = response?.error?.message?.code || response.error?.errors[0]?.reason
    const locale = i18n.locale
    const messages = i18n.messages[locale]

    if (errorKey && Object.keys(messages).includes(errorKey)) {
      return {
        message: messages[errorKey].format(messageValues),
        translated: true,
      }
    }

    const statusErrorKey = 'error' + status;

    if (status === 500 || status === 404 || status === 400) {
      return statusErrorKey;
    }

    return 'errorDefault';
  }
}
